import { authHeader } from "./auth-header";
import axiosInstance from "./axiosInstance";

const getAllVouchers = (params) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + "voucher", {
    headers: authHeader(),
    data: {},
    params,
    withCredentials: true,
  });
};

const createVoucher = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `voucher`,
    data,
    {
      withCredentials: true,
    }
  );
};

export default {
  getAllVouchers,
  createVoucher,
};
